import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { useContext, useState } from "react"
import { AuthContext } from "../contexts/AuthProvider";

import { doc, updateDoc, arrayUnion, increment } from "firebase/firestore";
import { db } from "../firebase/firebase";
import Explanation from "../components/Explanation";

import "../styling/Question.css"

export default function Question() {
    const { user, logout } = useContext(AuthContext);
    const { topicID, subtopicID, questionID } = useParams();
    const { state } = useLocation();

    const navigate = useNavigate();

    const questions = state.questions

    const [answer, setAnswer] = useState('');

    const [showAnswer, setShowAnswer] = useState(false);
    const [showNext, setShowNext] = useState(false);    
    const [isCorrect, setIsCorrect] = useState();

    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const value = e.target.value;

        // Allow only numbers (no spaces, commas, or other characters)
        if (/^\d*$/.test(value)) {
            setAnswer(value);
            setErrorMessage(""); // Clear warning if input is valid
        } else {
            setErrorMessage("Please enter a valid number (no spaces, commas, or letters).");
        }
    };


    const handleLogout = async () => {
        await logout();
        navigate("/"); 
    };

    const handleSubmit = async() => {
        setShowAnswer(true)
        setShowNext(true)

        const userProgressRef = doc(db, "user_progress", user.uid)
        const topicId = topicID
        const subtopicId = subtopicID
        const questionId = questions[Number(questionID)].id

        setIsCorrect(Number(answer) === questions[Number(questionID)].answer)

        if (Number(answer) === questions[Number(questionID)].answer) {
            await updateDoc(userProgressRef, {
                [`${topicId}.${subtopicId}.correctQuestions`]: arrayUnion(questionId),
                ["questionsCorrect"]: increment(1)
            });
        } else {
            await updateDoc(userProgressRef, {
                [`${topicId}.${subtopicId}.incorrectQuestions`]: arrayUnion(questionId)
            });
        }

        await updateDoc(userProgressRef, {
            [`${topicId}.${subtopicId}.amountCompleted`]: increment(1),
            ["questionsCompleted"]: increment(1)
        })
    }

    const handleNextQuestion = () => {
        if (Number(questionID) + 1 < questions.length) {
            navigate(`/topic/${topicID}/subtopic/${subtopicID}/question/${Number(questionID) + 1}`, {
                state: { questions }
            });
            
            setShowAnswer(false)
            setShowNext(false)
            setAnswer('')
        } else {
            navigate('/dashboard')
        }
    }

    const capitalizeSubtopic = (subtopic) => {
        return subtopic
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "); 
      };

    return (
        <div>
            <div className="navbar">
              <div className="navbar__left">
                <Link to="/dashboard">Home</Link>
              </div>
              <div className="navbar__right">
                <Link to="/dashboard">Practice</Link>
                <button className="navbar__sign-up-button" onClick={handleLogout}>
                  Sign Out
                </button>
              </div>
            </div>

            <div className="question-container">
                <h1 className="question__title">{capitalizeSubtopic(subtopicID)} - Question {Number(questionID) + 1}</h1>
                <p className="question__text">{questions[Number(questionID)].question}</p>
                <p className="question__note">Note: Answer must be in numbers only, no other characters.</p>
                <input 
                    className="question__answer"
                    value={answer}
                    onChange={handleChange}
                    placeholder="Enter your answer here..."
                />
                {!showNext && 
                    <button className="question__submit" onClick={handleSubmit}>
                        Submit
                    </button>
                }           
                {showNext && 
                    <button className="question__submit" onClick={handleNextQuestion}>
                        Next Question
                    </button>
                }
            
                {showAnswer && 
                    <div className="explanation-container">
                        <Explanation 
                            answerSteps={questions[Number(questionID)].answerSteps}
                            isCorrect={isCorrect}
                        />
                    </div>
                }
            </div>
        </div>
    )
}